import { Box, Link } from '@amzn/awsui-components-core';
import React from 'react';
import { ContactList } from 'src/components/das-finsuite/widgets/welcome-widget/ContactList';
import { sanitizeHtml } from 'src/utilities/SanitizeHtml';
import { WelcomeContentDetailsEntity } from '../../admin-components/AdminModels';

/** Converts display text to a valid HTML ID slug (no spaces or special characters). */
const toSlug = (text: string) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

interface WelcomeWidgetContentProps {
  welcomeContentDetails: WelcomeContentDetailsEntity[];
}

export const WelcomeWidgetContent: React.FC<WelcomeWidgetContentProps> = ({ welcomeContentDetails }) => {
  if (welcomeContentDetails.length === 0) {
    return <Box textAlign="center">No content</Box>;
  }

  return (
    <div>
      {welcomeContentDetails.map((welcomeItem, index) => (
        <WelcomeContentItem key={index} welcomeItem={welcomeItem} index={index} isLast={index === welcomeContentDetails.length - 1} />
      ))}
    </div>
  );
};

const WelcomeContentItem: React.FC<{
  welcomeItem: WelcomeContentDetailsEntity;
  index: number;
  isLast: boolean;
}> = ({ welcomeItem, index, isLast }) => {
  return (
    <div className="welcome-content-item" id={`welcome-item-${welcomeItem.id || toSlug(welcomeItem.displayText || '')}`}>
      {/* Row 1: Header and Contact List */}
      <div className="welcome-content-header">
        <div className="welcome-content-title">
          {welcomeItem.link ? (
            <Link variant="secondary" external href={welcomeItem.link}>
              {welcomeItem.displayText}
            </Link>
          ) : (
            <Box variant="awsui-key-label" color="text-status-info" fontSize="body-m" fontWeight="normal">
              {welcomeItem.displayText}
            </Box>
          )}
        </div>
        <div className="welcome-content-contact">{welcomeItem.pointOfContact && <ContactList userAlias={welcomeItem.pointOfContact} />}</div>
      </div>

      {/* Row 2: Description */}
      <Box fontSize="body-s" fontWeight="normal" padding={{ top: 'xxxs', bottom: 'xs' }}>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(welcomeItem.description || '')
          }}
        />
      </Box>

      {/* Horizontal bar */}
      {!isLast && <div className="horizontal-bar"></div>}
    </div>
  );
};
